<script setup lang="ts">
// biome-ignore lint/correctness/noUnusedImports: used via tag <UiPopup> in <template>
import { UiPopup } from '@/ui-kit';

interface Props {
  pendingCount: number;
  readyCount: number;
  sendReadyAvailable: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  sendReady: [];
  wait: [];
}>();
</script>

<template>
  <UiPopup size="sm" @close="emit('wait')">
    <div
      class="PortraitGenerationPendingDialog"
      data-testid="portraits-generation-pending"
    >
      <h2 class="PortraitGenerationPendingDialog__title">
        {{ $t('Portraits.generationPendingTitle') }}
      </h2>
      <p class="PortraitGenerationPendingDialog__caption">
        {{
          $t('Portraits.generationPendingCaption', {
            count: pendingCount,
          })
        }}
      </p>
      <div class="PortraitGenerationPendingDialog__actions">
        <button
          class="kiosk-button"
          data-testid="portraits-generation-pending-wait"
          @click="emit('wait')"
        >
          {{ $t('Portraits.generationPendingWait') }}
        </button>
        <button
          v-if="sendReadyAvailable"
          class="kiosk-button-inline"
          data-testid="portraits-generation-pending-send-ready"
          @click="emit('sendReady')"
        >
          {{
            $t('Portraits.generationPendingSendReady', {
              count: readyCount,
            })
          }}
        </button>
      </div>
    </div>
  </UiPopup>
</template>

<style scoped>
.PortraitGenerationPendingDialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.PortraitGenerationPendingDialog__title {
  margin-bottom: 1rem;
}

.PortraitGenerationPendingDialog__caption {
  margin-bottom: 1.5rem;
}

.PortraitGenerationPendingDialog__actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
</style>
